var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center"},[_c('UploadDocumentTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }